import React from 'react';
import styles from './Title.module.scss';
const Title = ({ children, ...props }) => {
  return <h1 {...props}>{children}</h1>;
};

export default Title;
